import { useStore, useStoreProps } from "./P63NRZ4A.js";
import { __spreadValues } from "./PNRLI7OV.js";

// src/disclosure/disclosure-store.ts
import * as Core from "@ariakit/core/disclosure/disclosure-store";
function useDisclosureStoreOptions(_props) {
  return {};
}
function useDisclosureStoreProps(store, props) {
  useStoreProps(store, props, "open", "setOpen");
  useStoreProps(store, props, "animated");
  return store;
}
function useDisclosureStore() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const options = useDisclosureStoreOptions(props);
  const store = useStore(() => Core.createDisclosureStore(__spreadValues(__spreadValues({}, props), options)));
  return useDisclosureStoreProps(store, props);
}
export { useDisclosureStoreOptions, useDisclosureStoreProps, useDisclosureStore };